module.exports = __webpack_public_path__ + "static/powerbi-home-0c34280c0ce0a692162f46c633f5f80a.png";